import ReadMore, { ReadMoreProps } from './ReadMore'
export default ReadMore
export { ReadMore }
export type { ReadMoreProps }
